module.exports = __webpack_public_path__ + "static/media/mexican-standoff.fd56c2b4.svg";